module.exports = __webpack_public_path__ + "img/30.4193ee11.png";